import { render, staticRenderFns } from "./ParentingArrangements.vue?vue&type=template&id=6b4060fb"
import script from "./ParentingArrangements.vue?vue&type=script&lang=ts"
export * from "./ParentingArrangements.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports